import * as THREE from "three";

export default class Earth {
  constructor() {
    this.mesh = new THREE.Object3D();

    const radius = 5;
    const segments = 32;

    const geometry = new THREE.SphereGeometry(radius, segments, segments);

    const textureLoader = new THREE.TextureLoader();

    // Load Earth textures
    const earthTexture = textureLoader.load("https://threejs.org/examples/textures/planets/earth_atmos_2048.jpg");
    const bumpMap = textureLoader.load("https://threejs.org/examples/textures/planets/earth_bump_2048.jpg");
    const specularMap = textureLoader.load("https://threejs.org/examples/textures/planets/earth_specular_2048.jpg");
    const cloudTexture = textureLoader.load("https://threejs.org/examples/textures/planets/earth_clouds_2048.png");

    const material = new THREE.MeshPhongMaterial({
      map: earthTexture,
      bumpMap: bumpMap,
      bumpScale: 0.05, // Adjust bump scale as needed
      specularMap: specularMap,
      specular: new THREE.Color("grey"),
      shininess: 5,
    });

    const earth = new THREE.Mesh(geometry, material);
    earth.castShadow = true;
    earth.receiveShadow = true;

    this.mesh.add(earth);

    // Clouds
    const cloudGeometry = new THREE.SphereGeometry(radius + 0.1, segments, segments);
    const cloudMaterial = new THREE.MeshLambertMaterial({
      map: cloudTexture,
      transparent: true,
      opacity: 0.4, // Adjust cloud opacity as needed
    });
    const clouds = new THREE.Mesh(cloudGeometry, cloudMaterial);
    this.mesh.add(clouds);

    // Add a light source for the Earth
    const light = new THREE.DirectionalLight(0xffffff, 1);
    light.position.set(1, 1, 1);
    this.mesh.add(light);

    // Add an ambient light
    const ambientLight = new THREE.AmbientLight(0x404040);
    this.mesh.add(ambientLight);
  }
}